import { getApiCall, postApiCall } from '../../utils/requests';
import { returnErrors } from '../ActionCreators/errorAction';
import {
    GET_BANNERS,
    GET_NEWS,
    GET_NEXT_NEWS,
    GET_TESTIMONIALS,
    GET_NUTRITION_INSTITUTES,
    GET_BANNERS_FOR_MASTER_CATALOGS,
    GET_MASTER_CATALOGS,
    GET_CATALOGS,
    GET_CUISINES,
    GET_FAQS,
    GET_PRODUCT_TYPES,
    GET_PRODUCTS,
    GET_NEXT_PRODUCTS,
    GET_RECIPES,
    GET_RECIPE_NUTRITIONS,
    GET_NEXT_RECIPES,
    GET_RECIPE_IMAGES,
    GET_PLATING_IMAGES,
    APPEND_PLATING_IMAGE,
    GET_PACKAGING_IMAGES,
    APPEND_PACKAGING_IMAGE,
    GET_SUBCATALOGS,
    SET_PRODUCT_TYPES,
    SET_PRODUCT,
    RESET_PRODUCTS,
    GET_MEAL_TYPE,
    RESET_RECIPES,
    RESET_RECIPES_LOADER,
    GET_CONTENTS,
    ADD_QUERY,
    SET_LANGUAGE,
    RECIPES_FAVORITES,
    REMOVE_FAV_RECIPES,
    GET_FAV_RECIPES,
    GET_NEXT_FAV_RECIPES,
    ADD_PRODUCT_QUANTITY
} from '../Types/types';


export const setLang = (val) => async (dispatch) => {
    try {
        dispatch({ type: SET_LANGUAGE, payload: val });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getBanners = () => async (dispatch) => {
    try {
        const response = await getApiCall(`/banners/website`);
        if (response.data.statusCode === 200) {
            dispatch({ type: GET_BANNERS, payload: response.data.data });
        }
        else {
            returnErrors(dispatch, response.data.message, response.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getBannersForMasterCatalogs = (id) => async (dispatch) => {
    return dispatch({ type: GET_BANNERS_FOR_MASTER_CATALOGS, payload: id });
}

export const getInstitutes = () => async (dispatch) => {
    try {
        const response = await getApiCall(`/nutrition-institutions/website`);
        if (response.data.statusCode === 200) {
            dispatch({ type: GET_NUTRITION_INSTITUTES, payload: response.data.data });
        }
        else {
            returnErrors(dispatch, response.data.message, response.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}
export const getNewsList = (page) => async (dispatch) => {
    try {
        const response = await getApiCall(`/openai-data/news/website?page=${page}`);
        if (response.data.statusCode === 200) {
            dispatch({ type: GET_NEWS, payload: response.data.data });
        }
        else {
            returnErrors(dispatch, response.data.message, response.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getNextNewsList = (page) => async (dispatch) => {
    try {
        const response = await getApiCall(`/openai-data/news/website?page=${page}`);
        if (response.data.statusCode === 200) {
            dispatch({ type: GET_NEXT_NEWS, payload: response.data.data });
        }
        else {
            returnErrors(dispatch, response.data.message, response.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getTestimonials = () => async (dispatch) => {
    try {
        const response = await getApiCall(`/testimonials/website`);
        if (response.data.statusCode === 200) {
            dispatch({ type: GET_TESTIMONIALS, payload: response.data.data });
        }
        else {
            returnErrors(dispatch, response.data.message, response.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getMasterCatalogs = () => async (dispatch) => {
    try {
        const response = await getApiCall(`/master-catalogs/website`);
        if (response.data.statusCode === 200) {
            return dispatch({ type: GET_MASTER_CATALOGS, payload: response.data.data });
        }
        else {
            returnErrors(dispatch, response.data.message, response.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}


export const getBuildCatalogs = (id) => async (dispatch) => {
    try {
        const response = await getApiCall(`/build-catalogs/website?masterCatalogId=${id ? id : ''}`);
        if (response.data.statusCode === 200) {
            return dispatch({ type: GET_CATALOGS, payload: response.data.data });
        }
        else {
            returnErrors(dispatch, response.data.message, response.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getBuildSubCatalogs = (id, type) => async (dispatch) => {
    try {
        let response = await getApiCall(`/build-sub-catalogs/website?buildCatalogId=${id ? id : ""}&masterCatalogTypes=${type ? type : ""}`);
        if (response.data.statusCode === 200) {
            return dispatch({ type: GET_SUBCATALOGS, payload: response.data.data });
        }
        else {
            returnErrors(dispatch, response.data.message, response.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getCuisines = (id) => async (dispatch) => {
    try {
        let response = await getApiCall(`/cuisines/website?buildCatalogId=${id ? id : ''}`);
        if (response.data.statusCode === 200) {
            return dispatch({ type: GET_CUISINES, payload: response.data.data });
        }
        else {
            returnErrors(dispatch, response.data.message, response.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getProductTypes = (id, scId) => async (dispatch) => {
    try {
        let response = await getApiCall(`/product-types/website?buildCatalogId=${id ? id : ""}&buildSubCatalogId=${scId ? scId : ''}`);
        if (response.data.statusCode === 200) {
            return dispatch({ type: GET_PRODUCT_TYPES, payload: response.data.data });
        }
        else {
            returnErrors(dispatch, response.data.message, response.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getProducts = (page, keyword, subcatalogid, cuisineId, id, prodType) => async (dispatch) => {
    try {
        const response = await getApiCall(`/products/website?page=${page}&keyword=${keyword}&buildSubCatalogId=${subcatalogid || ''}&cuisineId=${cuisineId || ''}&productTypeId=${id || ''}`);
        const data = response.data.data
        if (response.data.statusCode === 200) {
            return dispatch({ type: GET_PRODUCTS, payload: { data, prodType, id } });
        }
        else {
            returnErrors(dispatch, response.data.message, response.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getNextProducts = (page, keyword, subcatalogid, cuisineId, id, prodType) => async (dispatch) => {
    try {
        const response = await getApiCall(`/products/website?page=${page}&keyword=${keyword}&buildSubCatalogId=${subcatalogid || ''}&cuisineId=${cuisineId || ''}&productTypeId=${id || ''}`);
        const data = response.data.data
        if (response.data.statusCode === 200) {
            return dispatch({ type: GET_NEXT_PRODUCTS, payload: { data, prodType, id } });
        }
        else {
            returnErrors(dispatch, response.data.message, response.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

//Recipes
export const getRecipes = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`/openai-data/recipes/website`, obj);
        if (response.data.statusCode === 200) {
            return dispatch({ type: GET_RECIPES, payload: response.data.data });
        }
        else {
            returnErrors(dispatch, response.data.message, response.status);
            return dispatch({ type: GET_NEXT_RECIPES, payload: [] });
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
        return dispatch({ type: GET_NEXT_RECIPES, payload: [] });
    }
}

export const getNextRecipes = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`/openai-data/recipes/website`, obj);
        if (response.data.statusCode === 200) {
            return dispatch({ type: GET_NEXT_RECIPES, payload: response.data.data });
        }
        else {
            returnErrors(dispatch, response.data.message, response.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const resetRecipeLoader = () => async (dispatch) => {
    try {
        dispatch({ type: RESET_RECIPES_LOADER });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const resetRecipes = () => async (dispatch) => {
    try {
        dispatch({ type: RESET_RECIPES });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getRecipeNutritions = (el, id, page) => async (dispatch) => {
    let obj = {
        "recipeName": el.recipe_name,
        "servingSize": el.serving_size,
        "ingredients": el.ingredients_array
    }
    try {
        const response = await postApiCall(`/openai-data/recipe-nutritions/website`, obj);

        if (response.data.statusCode === 200) {
            const data = response.data.data?.nutritionData
            dispatch({ type: GET_RECIPE_NUTRITIONS, payload: { data, id, page } });
        }
        else {
            returnErrors(dispatch, response.data.message, response.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getRecipeImages = (recipe, id) => async (dispatch) => {
    const obj = {
        "recipeName": recipe.recipe_name,
        "ingredients": recipe.ingredients_array.map(item => item.item_name)
    }

    try {
        const response = await postApiCall(`/openai-data/recipe-image/website`, obj);
        if (response.data.statusCode === 200) {
            const data = response.data.data?.recipeImage
            return dispatch({ type: GET_RECIPE_IMAGES, payload: { data, id } });
        }
        else {
            returnErrors(dispatch, response?.data?.message, response?.status);
        }
    }
    // try {
    //     // Map over the recipes array and create an array of promises
    //     const promises = recipes.map(async (recipe, index) => {
    //         const response = await postApiCall(`/recipes/recipe-image/website`, {
    //             "recipeName": recipe.recipe_name,
    //             "ingredients": recipe.ingredients_array
    //         });
    //         if (response.data.statusCode === 200) {
    //             const data = response.data.data?.recipeImage;
    //             console.log(data)
    //             dispatch({ type: GET_RECIPE_IMAGES, payload: { data, id: index } });
    //             return { data, id: index }; // Assuming each recipe has an `id` field
    //         } else {
    //             return { error: response.data.message, status: response.status };
    //         }
    //     });

    //     // Wait for all promises to resolve
    //     const results = await Promise.all(promises);
    // }
    catch (error) {
        returnErrors(dispatch, error?.response?.data.message, error?.response?.status)
    }
}

export const getPlatingImages = (el, id, page) => async (dispatch) => {
    let obj = {
        "recipeName": el.recipe_name,
        isManualText: false,
        "platingContent": el.plating_creativity
    }
    try {
        const response = await postApiCall(`/openai-data/plating-images/website`, obj);

        if (response.data.statusCode === 200) {
            const data = response.data.data?.platingImages
            dispatch({ type: GET_PLATING_IMAGES, payload: { data, id, page } });
        }
        else {
            returnErrors(dispatch, response.data.message, response.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getImageUsingTxts = (name, val, id, page) => async (dispatch) => {
    let obj = {
        "recipeName": name,
        isManualText: true,
        "platingContent": [val]
    }
    try {
        const response = await postApiCall(`/openai-data/plating-images/website`, obj);

        if (response.data.statusCode === 200) {
            const data = response.data.data?.platingImages
            dispatch({ type: APPEND_PLATING_IMAGE, payload: { data, id, val, page } });
        }
        else {
            returnErrors(dispatch, response.data.message, response.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getPackagingImages = (el, id, page) => async (dispatch) => {
    let obj = {
        "recipeName": el.recipe_name,
        isManualText: false,
        "packageWrapLabelingContent": el.package_wrap_labeling
    }
    try {
        const response = await postApiCall(`/openai-data/package-labeling-images/website`, obj);

        if (response.data.statusCode === 200) {
            const data = response.data.data?.packageLabelingImages
            dispatch({ type: GET_PACKAGING_IMAGES, payload: { data, id, page } });
        }
        else {
            returnErrors(dispatch, response.data.message, response.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getPackagingImageUsingTxts = (name, val, id, page) => async (dispatch) => {
    let obj = {
        "recipeName": name,
        isManualText: true,
        "packageWrapLabelingContent": [val]
    }
    try {
        const response = await postApiCall(`/openai-data/package-labeling-images/website`, obj);

        if (response.data.statusCode === 200) {
            const data = response.data.data?.packageLabelingImages
            dispatch({ type: APPEND_PACKAGING_IMAGE, payload: { data, id, val, page } });
        }
        else {
            returnErrors(dispatch, response.data.message, response.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getFavoriteRecipes = (page, search) => async (dispatch) => {
    try {
        const response = await getApiCall(`/openai-data/favorite-recipes?page=${page}&keyword=${search ? search : ""}`);
        if (response.data.statusCode === 200) {
            return dispatch({ type: GET_FAV_RECIPES, payload: response.data.data });
        }
        else {
            returnErrors(dispatch, response.data.message, response.status);
            return dispatch({ type: GET_NEXT_FAV_RECIPES, payload: [] });
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
        return dispatch({ type: GET_NEXT_FAV_RECIPES, payload: [] });
    }
}


export const addRecipeFavorites = (obj, idx) => async (dispatch) => {
    try {
        const response = await postApiCall(`/openai-data/favorite-recipes`, obj);
        if (response.data.statusCode === 200) {
            const id = obj?.isFavorite ? response.data.data.recipeId : ''
            console.log(id)
            returnErrors(dispatch, obj?.isFavorite ? 'Recipe added to my favorites' : 'Recipe removed from favorites', response.status);
            return dispatch({ type: RECIPES_FAVORITES, payload: { obj, idx, id } });
        }
        else {
            returnErrors(dispatch, response.data.message, response.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const removeFavRecipes = (obj, id) => async (dispatch) => {
    try {
        const response = await postApiCall(`/openai-data/favorite-recipes`, obj);
        if (response.data.statusCode === 200) {
            returnErrors(dispatch, response.data.message, response.status);
            return dispatch({ type: REMOVE_FAV_RECIPES, payload: { ...obj, id } });
        }
        else {
            returnErrors(dispatch, response.data.message, response.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}



export const getFaqs = () => async (dispatch) => {
    try {
        const response = await getApiCall(`/faqs/website`);
        if (response.data.statusCode === 200) {
            dispatch({ type: GET_FAQS, payload: response.data.data });
        }
        else {
            returnErrors(dispatch, response.data.message, response.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getContents = () => async (dispatch) => {
    try {
        const response = await getApiCall(`/contents/website`);
        if (response.data.statusCode === 200) {
            dispatch({ type: GET_CONTENTS, payload: response.data.data });
        }
        else {
            returnErrors(dispatch, response.data.message, response.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const queryAdd = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`/user-queries/website`, obj);
        if (response.data.statusCode === 200) {
            returnErrors(dispatch, response.data.message, response.status);
            return dispatch({ type: ADD_QUERY });
        }
        else {
            returnErrors(dispatch, response.data.message, response.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const setActiveType = (obj) => async (dispatch) => {
    try {
        dispatch({ type: SET_PRODUCT_TYPES, payload: obj });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const setActiveProduct = (obj) => async (dispatch) => {
    try {
        dispatch({ type: SET_PRODUCT, payload: obj });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const resetProducts = (id) => async (dispatch) => {
    try {
        dispatch({ type: RESET_PRODUCTS, payload: id });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getMealSubCatalogs = (id, type) => async (dispatch) => {
    try {
        let response = await getApiCall(`/build-sub-catalogs/website?buildCatalogId=${id ? id : ""}&masterCatalogTypes=${type ? type : ""}`);
        if (response.data.statusCode === 200) {
            return dispatch({ type: GET_MEAL_TYPE, payload: response.data.data });
        }
        else {
            returnErrors(dispatch, response.data.message, response.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const addQuantity = (val, id) => async (dispatch) => {
    try {
        dispatch({ type: ADD_PRODUCT_QUANTITY, payload: { val, id } });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}


